<template>
  <div>
    <TheHeader
      class="bg-grey-lightest md:bg-white"
      with-menu
    />
    <TheBackgroundHeader opportunity-background >
      <BaseSection class="mb-4">
        <BaseTitleGroup
          :title="$t('New opportunities')"
        />
      </BaseSection>
    </TheBackgroundHeader>
    <BaseSection
      class="md:flex-row md:flex-wrap
      justify-between opportunity-list md:mb-10 min-h-half mb-15"
    >
      <template
        v-if="list.length"
      >
        <div
          v-for="opportunity in list"
          :key="opportunity.id"
          class="border-b border-shadow-color py-4 md:p-6 md:rounded
            md:border md:w-2/5 md:mb-8 opportunity-element"
        >
          <router-link :to="`/opportunities/${opportunity.id}`">
            <div
              class="flex justify-between mb-2 mr-2"
            >
              <div class="flex flex-col">
                <BaseListHeader
                  :title="opportunity.attributes.name"
                  class="mb-1"
                />
                <div
                  v-if="opportunity.attributes.wishesDisabled"
                >
                  <BaseOrangeText class="font-heavy">{{ $t('Opening soon') }}</BaseOrangeText>
                </div>
                <div
                  v-else-if="opportunity.attributes.closedAt"
                  class="mb-2px mr-2"
                >
                  <BaseOrangeText class="font-heavy">Phase administrative en cours</BaseOrangeText>
                </div>
                <BaseProgressBarHeader
                  v-else
                  :current="opportunity.attributes.wishesAmount"
                  :total="opportunityTotal(opportunity)"
                  :goal="opportunity.attributes.targetAmount"
                  :over-subscription="opportunity.attributes.overSubscription"
                />
              </div>
              <BaseRoundLogo :logo="opportunity.attributes.logo" />
            </div>
            <BaseProgressBar
              :current="opportunity.attributes.wishesAmount"
              :goal="opportunity.attributes.targetAmount"
              :over-subscription="opportunity.attributes.overSubscription"
              :with-header="false"
            />
          </router-link>
        </div>
      </template>
      <BaseEmptyState
        v-else-if="!list.length"
      >
        Il n'y a pas de nouvelle opportunité en cours
        <br><br>
        Vous recevrez une notification par email dès la
        prochaine opportunité émise par Kerala
        <BaseButton
          slot="button"
          href="https://www.kerala.vc/portfolio"
          title="Accéder au portfolio"
          theme="outlined"
          padded
        />
      </BaseEmptyState>
    </BaseSection>
    <TheFooter />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseListHeader from '../components/BaseListHeader.vue';
import BaseProgressBarHeader from '../components/BaseProgressBarHeader.vue';
import BaseProgressBar from '../components/BaseProgressBar.vue';
import BaseRoundLogo from '../components/BaseRoundLogo.vue';
import BaseEmptyState from '../components/BaseEmptyState.vue';
import BaseButton from '../components/BaseButton.vue';
import BaseParagraph from '../components/BaseParagraph.vue';
import BaseOrangeText from '../components/BaseOrangeText.vue';
import TheBackgroundHeader from '../components/TheBackgroundHeader.vue';
import Document from '../components/icons/Document.vue';
import TheFooter from '../components/TheFooter.vue';

export default {

  name: 'Opportunities',

  metaInfo: {
    title: 'Nouvelles opportunités',
  },

  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseListHeader,
    BaseProgressBarHeader,
    BaseRoundLogo,
    BaseProgressBar,
    TheBackgroundHeader,
    BaseEmptyState,
    BaseButton,
    BaseParagraph,
    Document,
    TheFooter,
    BaseOrangeText,
  },

  computed: {
    ...mapState('opportunity', ['list']),
    ...mapGetters('auth', ['hasValidKyc', 'hasValidatedKyc', 'hasSubmittedKyc', 'hasOngoingKyc']),
    kycButtonTitle() {
      return this.hasOngoingKyc ? this.$t('Continue') : this.$t('Begin');
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    ...mapActions('opportunity', {
      fetchData: 'fetchList',
      logout: 'logout',

    }),
    opportunityTotal(opportunity) {
      return opportunity.attributes.targetAmount +
      (opportunity.attributes.overSubscription *
        (opportunity.attributes.targetAmount /
        100
        )
      );
    },
  },
};
</script>
